module.exports = __webpack_public_path__ + "static/media/purple.8aa85d83.png";